
import { usePlatform } from './use-platform';

export function useHaptics() {
  const { isNative } = usePlatform();

  const triggerHaptic = async (type: 'light' | 'medium' | 'heavy' = 'light') => {
    if (isNative) {
      try {
        const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
        
        const impactStyle = {
          light: ImpactStyle.Light,
          medium: ImpactStyle.Medium,
          heavy: ImpactStyle.Heavy
        };

        await Haptics.impact({ style: impactStyle[type] });
      } catch (error) {
        console.error('Haptics error:', error);
      }
    } else {
      // Fallback for web
      if ('vibrate' in navigator) {
        const duration = { light: 50, medium: 100, heavy: 200 };
        navigator.vibrate(duration[type]);
      }
    }
  };

  return { triggerHaptic };
}
